import { render } from "./TaskDetails.vue?vue&type=template&id=305430f6&scoped=true"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=305430f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-305430f6"

export default script